const FilterModal = ({
  show,
  onClose,
  dateFilters,
  tempValues,
  handleDateChange,
  handleDateBlur,
  selectedMonthYear,
  monthYearOptions,
  handleMonthChange,
  agentNames,
  selectedAgents,
  handleAgentChange,
  showCustomOption
}) => {
  if (!show) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1050
    }} onClick={handleOverlayClick}>
      <div className="modal-content" style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        width: '90%',
        maxWidth: '800px',
        maxHeight: '90vh',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <div className="modal-header" style={{
          padding: '1rem',
          borderBottom: '1px solid #dee2e6',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h5 className="modal-title" style={{ marginBottom: 0 }}>Фильтры</h5>
          <button
            type="button"
            className="btn-close"
            onClick={onClose}
            style={{
              background: 'transparent',
              border: 'none',
              fontSize: '1.5rem',
              lineHeight: 1,
              color: '#000',
              opacity: 0.5
            }}
          >
            ×
          </button>
        </div>
        
        <div className="modal-body" style={{
          padding: '1rem',
          overflowY: 'auto',
          flex: 1
        }}>
          <div className="row g-3">
            {/* Фильтры дат */}
            <div className="col-md-6">
              <label className="form-label">Дата от</label>
              <input
                type="datetime-local"
                name="date_filter_from"
                className="form-control form-control-sm"
                value={tempValues.date_filter_from || dateFilters.date_filter_from}
                onChange={handleDateChange}
                onBlur={handleDateBlur}
                step="1"
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Дата до (с секундами)</label>
              <input
                type="datetime-local"
                name="date_filter_to"
                className="form-control form-control-sm"
                value={tempValues.date_filter_to || dateFilters.date_filter_to}
                onChange={handleDateChange}
                onBlur={handleDateBlur}
                step="1"
              />
            </div>
            
            {/* Фильтр по месяцу */}
            <div className="col-12">
              <label className="form-label">Фильтр по месяцу</label>
              <select
                className="form-control form-control-sm"
                value={selectedMonthYear || ''}
                onChange={handleMonthChange}
              >
                <option value="">Все месяцы</option>
                {monthYearOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
                {selectedMonthYear && !monthYearOptions.some(opt => opt.value === selectedMonthYear) && (
                  <option value={selectedMonthYear} disabled>
                    Загруженный месяц (недоступен)
                  </option>
                )}
                {showCustomOption && (
                  <option value="" disabled>
                    Ручной промежуток
                  </option>
                )}
              </select>
            </div>
            
            {/* Фильтр по агентам */}
            {agentNames.length > 0 && (
              <div className="col-12">
                <label className="form-label d-block">Фильтр по операторам</label>
                <div className="agent-checkboxes-container" style={{ 
                  maxHeight: '200px', 
                  overflowY: 'auto', 
                  border: '1px solid #ddd', 
                  borderRadius: '4px', 
                  padding: '10px', 
                  backgroundColor: '#f9f9f9' 
                }}>
                  {agentNames.map((agentName) => (
                    <div key={agentName} className="form-check form-check-inline" style={{ minWidth: '200px' }}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`agent-${agentName}`}
                        checked={selectedAgents.includes(agentName)}
                        onChange={() => handleAgentChange(agentName)}
                      />
                      <label className="form-check-label" htmlFor={`agent-${agentName}`} style={{ fontSize: '14px' }}>
                        {agentName}
                      </label>
                    </div>
                  ))}
                </div>
                <small className="text-muted">
                  Выбрано операторов: {selectedAgents.length} из {agentNames.length}
                </small>
              </div>
            )}
          </div>
        </div>
        
        <div className="modal-footer" style={{
          padding: '1rem',
          borderTop: '1px solid #dee2e6',
          display: 'flex',
          justifyContent: 'flex-end'
        }}>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onClose}
            style={{
              padding: '0.375rem 0.75rem',
              fontSize: '1rem',
              borderRadius: '0.25rem'
            }}
          >
            Закрыть
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterModal;